<template>
  <div>
    <CModuleHeader>{{ $t('points') }}</CModuleHeader>
    <CModuleContent
      :height="12"
      :horizontalMargin="2"
    >
  
    <div class="row mt-1">
      <div 
        class="col-6 text-over text-left"
        @mouseenter="emitContextualHelpChanged('nbPoint')"
        @mouseleave="emitContextualHelpChanged(null)"
      >{{ $t('nbPoints') }}</div>
      <div class="col-6">{{ nbPoints }}</div>
    </div>
    
    <div v-if="algoSelected !== 'custom'" class="row mt-1">
      <div 
        class="col-6 text-over text-left"
        @mouseenter="emitContextualHelpChanged('maxPoints')"
        @mouseleave="emitContextualHelpChanged(null)"
      >
        {{ $t('maxPoints') }}
      </div>
      <div class="col-6">
        <TrinnovInput
          buttonType="numberIncrement"
          :modelValue="maxNbPoints"
          :min="minIncrementPoints"
          :max="maxIncrementPoints"
          size="auto"
          :event="true"
          @TrinnovInputChanged="emitMaxPointChanged"
        ></TrinnovInput>
      </div>

    </div>
  </CModuleContent>
  </div>

</template>

<script>
import TrinnovInput from '@/lib/tui/components/buttons/TrinnovInput.vue';
import CModuleHeader from "@/lib/tui/template/container/module/CModuleHeader.vue";
import CModuleContent from "@/lib/tui/template/container/module/CModuleContent.vue";
export default {
  name: "CPoints",
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  components: {
    TrinnovInput,
    CModuleHeader,
    CModuleContent
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  props: {
    nbPoints: Number,
    maxNbPoints: Number,
    algoSelected: String
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  data () {
    return {
      minIncrementPoints: 10,
      maxIncrementPoints: 30,
    }
  },
  ///////////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////////
  methods: {
    emitMaxPointChanged: function(event) {
      this.$emit("MaxPointChanged", event.value);
    },
    ///////////////////////////////////////////////////////////////
    emitContextualHelpChanged: function(event) {
      this.$emit("ContextualHelpChanged", event);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>